<script lang="ts" setup>
import Visibility from './Visibility.vue';

const menu = ref(null);
const show = ref(false);
const menuBounce = ref(null);

useIntersectionObserver(menu, ([{ isIntersecting, intersectionRatio }]) =>
{
    if (isIntersecting && menuBounce.value === null)
    {
        menuBounce.value = intersectionRatio != 1;
    }
},
{ threshold: [0, 1] });

onClickOutside(menu, () =>
{
    onClose();
});

function onToggle()
{
    show.value = !show.value;
}

function onClose()
{
    show.value = false;
}
</script>

<template>
    <div class="dropdown">
        <button class="btn btn-text-normal" :class="{ 'btn-light': !show, 'btn-dark': show }" @click.prevent.stop="onToggle()">
            <div class="d-flex">
                <div>
                    {{ $t('[[[Więcej]]]') }}
                </div>
                <div class="ms-2">
                    <i class="fas fa-fw fa-plus" />
                </div>
            </div>
        </button>
        <div ref="menu" class="dropdown-menu shadow menu-width" :class="{ 'show': show, 'end-0': menuBounce }">
            <Visibility @close="onClose" />
        </div>
    </div>
</template>

<style scoped>
.menu-width {
    min-width: 300px;
}
</style>
